import { PlaybookCardsSection } from '@/playbooks/components/PlaybookCardsSection'
import { PlaybookCreationForm } from '@/playbooks/components/PlaybookCreationForm'
import { CustomLogo } from '@/shared/components/CustomLogo'
import { Footer } from '@/shared/components/Footer'
import { SidebarLayout } from '@/shared/components/SidebarLayout'
import { TimeBasedUserGreeting } from '@/static-pages/components/TimeBasedUserGreeting'
import React, { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const Dashboard: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const newPlaybook = searchParams.get('new')
  const creationFormRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    document.title = 'Dashboard | Mydra'
  }, [])

  useEffect(() => {
    if (newPlaybook) {
      creationFormRef.current?.scrollIntoView({ behavior: 'smooth' })
      creationFormRef.current?.focus()
      navigate('/dashboard', { replace: true })
    }
  }, [newPlaybook, searchParams, navigate])

  return (
    <SidebarLayout key="dashboard">
      <div className="mx-auto">
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(137, 90, 215, 0.20) 0%, rgba(243, 167, 123, 0.20) 8.67%, rgba(255, 255, 255, 0.20) 25.22%), #FFF',
            backgroundSize: '100% 1027px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
          }}
          className="flex flex-col gap-20 md:mx-5 md:mt-4 md:rounded-xl"
        >
          <div className="mt-20 flex w-full max-w-full flex-col items-center gap-4 px-6 md:mx-auto md:w-[800px]">
            <div className="flex justify-start">
              <CustomLogo size={120} />
            </div>

            <TimeBasedUserGreeting className="text-center" />

            <PlaybookCreationForm variant="playbook" ref={creationFormRef} />
          </div>
          <div className="px-6">
            <PlaybookCardsSection
              maxPlaybooks={6}
              filters={{ isCommunity: true }}
            />
          </div>
        </div>
        <div className="md:hidden">
          <Footer />
        </div>
      </div>
    </SidebarLayout>
  )
}

export default Dashboard
